var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-views" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c(
            "th",
            {
              staticStyle: {
                "text-align": "left",
                "vertical-align": "middle",
                padding: "20px 10px"
              },
              attrs: { colspan: "2" }
            },
            [
              _c("swb-task-symb", {
                attrs: { taskPhaseConf: _vm.taskPhaseConf }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.innerList, function(taskData) {
          return _c(
            "tr",
            { staticStyle: { "border-top": "1px dotted #AAAAAA" } },
            [
              _c(
                "td",
                {
                  staticStyle: {
                    padding: "10px 0px",
                    "min-width": "90px !important"
                  }
                },
                [
                  _c("div", { staticClass: "line-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.actorMode ? taskData.theActor : taskData.theDate
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: { padding: "10px 0px", width: "90% !important" }
                },
                [
                  _c("swb-task-line", {
                    attrs: {
                      startTime: _vm.startTime,
                      endTime: _vm.endTime,
                      specialHours: _vm.specialHours,
                      taskNodeConf: _vm.taskNodeConf,
                      taskPhaseConf: _vm.taskPhaseConf,
                      taskPhaseInfoProvider: _vm.taskPhaseInfoProvider,
                      taskClickHandler: _vm.taskClickHandler,
                      taskData: taskData
                    }
                  })
                ],
                1
              )
            ]
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20115fd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20115fd4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/task/TaskViews.vue
// module id = 4650
// module chunks = 0